import React, { ChangeEvent } from 'react';
import { Components } from './styled';

const ProjectTableHeader = ({
  onSearchChange,
  searchLabel,
  searchPlaceholder,
  children,
  setFilter,
  filter,
}: {
  onSearchChange: (e: ChangeEvent<HTMLInputElement>) => void;
  searchLabel?: string;
  searchPlaceholder?: string;
  children?: React.ReactNode;
  setFilter?: React.Dispatch<React.SetStateAction<boolean>>;
  filter?: boolean;
}) => {
  const _onSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    onSearchChange(e);
    if (!filter) {
      setFilter?.(true);
    }
  };

  return (
    <Components.Container>
      <Components.FieldWrapper>
        {searchLabel && <Components.FieldLabel>{searchLabel}</Components.FieldLabel>}
        <Components.TextFieldContainer>
          <Components.TextField
            type={'search'}
            onChange={_onSearchChange}
            placeholder={searchPlaceholder || 'Enter search terms'}
          />
        </Components.TextFieldContainer>
      </Components.FieldWrapper>
      {children}
    </Components.Container>
  );
};

export default ProjectTableHeader;
